import React, {useState, setGlobal, getGlobal, useEffect} from 'reactn';
import { Radio, Checkbox, Button, Skeleton, Switch, notification, Popover } from 'antd';
import { useFirestore } from 'reactfire';


const LeftNose = (props) => {

    const [isLeftNose, setLeftNose] = useState('No');
    const [popup, setPopup] = useState(false);

    const firestore = useFirestore();
    const [count, setCount] = useState(1);

    const [state, setState] = useState();
    const [loading, setLoading] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);
    
    const getSelectedFields = (event) => {
        setState({
            ...state,
            [event.target.name] : event.target.value
        });
    }

    useEffect(() => {
        if (count<3) {
            getCurrentExmLocation();
        }
    }, [props, count]);

    const getCurrentExmLocation = () => {
        setLoading(true);
        if (getGlobal().examination_location) {
            setState(getGlobal().examination_location.LeftNose && getGlobal().examination_location.LeftNose);
            setLeftNose(getGlobal().examination_location.LeftNose && getGlobal().examination_location.LeftNose.isLeftNose
                ? getGlobal().examination_location.LeftNose.isLeftNose : 'No');
                let c = count + 1;
                setCount(c);
         }
         assignDefaultValues();

         setLoading(false);


    }

    const assignDefaultValues = () => {
        if (!state) {
            assignDefaultValuesAnyways();
        }
    }

    const assignDefaultValuesAnyways = () => {
        setState({
            'External Nose' : 'No Deformity',
            'Scar Mark' : 'No',
            'Tele-canthus' : 'No',
            'Inter-Pupillary distance' : 'Normal',
            'Proptosis' : 'No',
            'Nose' : 'Non Tender & No Swelling',
            'Maxillary' : 'Non Tender & No Swelling',
            'Ethmoid' : 'Non Tender & No Swelling',
            'Frontal' : 'Non Tender & No Swelling',
            'Nasal Patency' : 'Normal',
            'Sense of Smell' : 'Normal',
            'Septum' : 'No Deformity',
            'Inferior Turbinate' : 'Normal',
            'Middle Turbinate' : 'Normal',
            'Mass' : 'No Mass',
            'Nasal Discharge 1' : 'Not Present',
            'Nasal Discharge 2' : 'Not Foul smelling',
            'Nasal Discharge 3' : 'Not Blood Stained',
            'Mobility' : 'No Present',
            'Retraction' : 'No',
            'Light Reflex' : 'Normal',
            'Perforation' : 'No',
            'Size of Perforation1' : 'Anterio-inferior',
            'Size of Perforation2' : 'Small',
            'Voice' : 'Normal',
            'Rinnes Test' : 'Not Done',
            'Wabbers Test' : 'Not Done',
            'ABC Test' : 'Not Done',
            'Facial Nerve' : 'Intact',
            'Trigeminal Sensations' : 'Intact',
            'Corneal Sensations' : 'Intact',
            'Extra Ocular Movements' : 'Intact',
            'Nystagmus' : 'Nil',
            'Cerebellar Functions' : 'Intact',
            'Vestibular Functions' : 'Intact',
            'Type of hearing Loss' : 'No Loss',
            'Severity' : 'Nil'

            
        });
    }

    const getCheckBoxONChange = (value, target) => {
        setState({
            ...state,
            [target] : value
        });
    }

    const saveTheForm = () => {
        setLoadingBtn(true);
        let objectToSave = {
            ...getGlobal().examination_location,
            'LeftNose' : {'isLeftNose': isLeftNose, ...state}
        }

        if (getGlobal().examination_location_id) {
            firestore.collection('Examination').doc(getGlobal().examination_location_id).update({
                examination_location: objectToSave,
            }).then(() => {
                notification.open({
                    message: 'Record Successfully Updated',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).catch(() => {
                notification.open({
                    message: 'An Error Occured',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).finally(() => {
                props.hasSaved();
                setLoadingBtn(false);
            });
        } else {
            firestore.collection('Examination').add({
                patient: firestore.collection("patients").doc(getGlobal().patientID),
                appointment: firestore.collection("appointments").doc(getGlobal().appointmentId),
                appointment_id: getGlobal().appointmentId,
                date: new Date(),
                examination_location: objectToSave,
            }).then(() => {
                notification.open({
                    message: 'Record Successfully Added',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).catch(() => {
                notification.open({
                    message: 'An Error Occured',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).finally(() => {
                props.hasSaved();
                setLoadingBtn(false);
            });
        }
  

        
    }

    const deleteLeftNose = () => {


        firestore.collection('Examination').doc(getGlobal().examination_location_id).update({
            examination_location: {...getGlobal().examination_location, LeftNose: null}
            
        }).then(() => {
            notification.open({
                message: 'Record Successfully Delete',
                // icon: <DeleteOutlined style={{ color: '#f00' }} />,
            });
            setGlobal({examination_location: {...getGlobal().examination_location, LeftNose: null}})
            setPopup(!popup)
            props.hasSaved();
            assignDefaultValuesAnyways();
        }).catch(() => {
            notification.open({
                message: 'An Error Occured',
                // icon: <DeleteOutlined style={{ color: '#f00' }} />,
            });
        });


      
    }




    const LeftNoseSelect = (event) => {
        setLeftNose(event.target.value);
    }

    return (
        <div>
            <React.Fragment>
            {loading ? <Skeleton active /> : <>
               <Radio.Group name="LeftNose" value={isLeftNose} onChange={LeftNoseSelect} buttonStyle="solid" size="large" style={{marginTop: '20px'}}>
                <Radio.Button value={'Yes'}>Yes</Radio.Button>
                    

                    <Popover
                        content={<a onClick={deleteLeftNose}>Delete</a>}
                        title="Are you sure you want to delete All Record of LeftNose?"
                        trigger="click"
                        visible={popup}
                        onVisibleChange={() => {
                            if(getGlobal().examination_location && getGlobal().examination_location.LeftNose){setPopup(!popup)}
                        }}
                    >
                        {/* <DeleteOutlined /> */}
                        <Radio.Button value={'No'}>No</Radio.Button>

                        
                    
                    </Popover>
               </Radio.Group>
               {isLeftNose === 'Yes' && <Button className="SaveFormButton" loading={loadingBtn} style={{float: 'right'}} onClick={saveTheForm} type="primary">Save</Button>}
                   

                {isLeftNose === 'Yes' ? 
                    
                    <ul className='showFieldsTable'>
                        <li><span>External Nose</span>
                            <Radio.Group name="External Nose" value={state && state['External Nose']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'No Deformity'}>No Deformity</Radio.Button>
                                <Radio.Button value={'Rt Sided'}>Rt Sided</Radio.Button>
                                <Radio.Button value={'Lt sided'}>Lt sided</Radio.Button>
                                <Radio.Button value={'Bilateral'}>Bilateral</Radio.Button>
                                <Radio.Button value={'other'}>other</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Scar Mark</span>
                            {/* <Radio.Group name="Scar Mark" value={state && state['Scar Mark']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Lateral Rhinotomy'}>Lateral Rhinotomy</Radio.Button>
                                <Radio.Button value={'Weber Fergossan'}>Weber Fergossan</Radio.Button>
                                <Radio.Button value={'Rhinoplasty'}>Rhinoplasty</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group> */}
                            <Checkbox.Group name="Scar Mark" value={state && state['Scar Mark']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Scar Mark')} size="large">
                                <Checkbox value="No" style={{ lineHeight: '32px' }}>
                                No
                                </Checkbox>
                                <Checkbox value="Lateral Rhinotomy" style={{ lineHeight: '32px' }}>
                                Lateral Rhinotomy
                                </Checkbox>
                                <Checkbox value="Weber Fergossan" style={{ lineHeight: '32px' }}>
                                Weber Fergossan
                                </Checkbox>
                                <Checkbox value="Rhinoplasty" style={{ lineHeight: '32px' }}>
                                Rhinoplasty
                                </Checkbox>
                                <Checkbox value="other" style={{ lineHeight: '32px' }}>
                                other
                                </Checkbox>
                            </Checkbox.Group>
                        </li>
                        <li><span>Tele-canthus</span>
                            <Radio.Group name="Tele-canthus" value={state && state['Tele-canthus']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Present'}>Present</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Inter-Pupillary distance</span>
                            <Radio.Group name="Inter-Pupillary distance" value={state && state['Inter-Pupillary distance']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                <Radio.Button value={'Increased'}>Increased</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Proptosis</span>
                            <Radio.Group name="Proptosis" value={state && state['Proptosis']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Present'}>Present</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span style={{fontSize:'18px'}}>Tenderness Swelling</span>
                            <ul className='nestedUl'>
                                <li><span>Nose</span>
                                    <Radio.Group name="Nose" value={state && state['Nose']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'Non Tender & No Swelling'}>Non Tender & No Swelling</Radio.Button>
                                        <Radio.Button value={'Tender & Swelling'}>Tender & Swelling</Radio.Button>
                                        <Radio.Button value={'Only Tender'}>Only Tender</Radio.Button>
                                        <Radio.Button value={'Only Swelling'}>Only Swelling</Radio.Button>
                                        <Radio.Button value={'Other'}>Other</Radio.Button>
                                    </Radio.Group>
                                </li>
                                <li><span>Maxillary</span>
                                    <Radio.Group name="Maxillary" value={state && state['Maxillary']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'Non Tender & No Swelling'}>Non Tender & No Swelling</Radio.Button>
                                        <Radio.Button value={'Tender & Swelling'}>Tender & Swelling</Radio.Button>
                                        <Radio.Button value={'Only Tender'}>Only Tender</Radio.Button>
                                        <Radio.Button value={'Only Swelling'}>Only Swelling</Radio.Button>
                                        <Radio.Button value={'Other'}>Other</Radio.Button>
                                    </Radio.Group>
                                </li>
                                <li><span>Ethmoid</span>
                                    <Radio.Group name="Ethmoid" value={state && state['Ethmoid']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'Non Tender & No Swelling'}>Non Tender & No Swelling</Radio.Button>
                                        <Radio.Button value={'Tender & Swelling'}>Tender & Swelling</Radio.Button>
                                        <Radio.Button value={'Only Tender'}>Only Tender</Radio.Button>
                                        <Radio.Button value={'Only Swelling'}>Only Swelling</Radio.Button>
                                        <Radio.Button value={'Other'}>Other</Radio.Button>
                                    </Radio.Group>
                                </li>
                                <li><span>Frontal</span>
                                    <Radio.Group name="Frontal" value={state && state['Frontal']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'Non Tender & No Swelling'}>Non Tender & No Swelling</Radio.Button>
                                        <Radio.Button value={'Tender & Swelling'}>Tender & Swelling</Radio.Button>
                                        <Radio.Button value={'Only Tender'}>Only Tender</Radio.Button>
                                        <Radio.Button value={'Only Swelling'}>Only Swelling</Radio.Button>
                                        <Radio.Button value={'Other'}>Other</Radio.Button>
                                    </Radio.Group>
                                </li>
                            </ul>
                        </li>
                        <li><span>Nasal Patency</span>
                            <Radio.Group name="Nasal Patency" value={state && state['Nasal Patency']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                <Radio.Button value={'Decreased On Rt Side'}>Decreased On Rt Side</Radio.Button>
                                <Radio.Button value={'Decreased On Lt Side'}>Decreased On Lt Side</Radio.Button>
                                <Radio.Button value={'Decreased On Both Side'}>Decreased On Both Side</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Sense of Smell</span>
                            <Radio.Group name="Sense of Smell" value={state && state['Sense of Smell']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                <Radio.Button value={'Decreased On Rt Side'}>Decreased On Rt Side</Radio.Button>
                                <Radio.Button value={'Decreased On Lt Side'}>Decreased On Lt Side</Radio.Button>
                                <Radio.Button value={'Decreased On Both Side'}>Decreased On Both Side</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span style={{fontSize:'18px'}}>Nasal Cavity</span>
                            <ul className='nestedUl'>
                                <li><span>Septum</span>
                                    {/* <Radio.Group name="Septum" value={state && state['Septum']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'No Deformity'}>No Deformity</Radio.Button>
                                        <Radio.Button value={'Caudal dislocation'}>Caudal dislocation</Radio.Button>
                                        <Radio.Button value={'RT DNS'}>RT DNS</Radio.Button>
                                        <Radio.Button value={'LT DNS'}>LT DNS</Radio.Button>
                                        <Radio.Button value={'Bilateral DNS'}>Bilateral DNS</Radio.Button>
                                        <Radio.Button value={'S-Shaped DNS'}>S-Shaped DNS</Radio.Button>
                                        <Radio.Button value={'C-Shaped DNS'}>C-Shaped DNS</Radio.Button>
                                    </Radio.Group> */}
                                    <Checkbox.Group name="Septum" value={state && state['Septum']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Septum')} size="large">
                                        <Checkbox value="No Deformity" style={{ lineHeight: '32px' }}>
                                        No Deformity
                                        </Checkbox>
                                        <Checkbox value="Caudal dislocation" style={{ lineHeight: '32px' }}>
                                        Caudal dislocation
                                        </Checkbox>
                                        <Checkbox value="RT DNS" style={{ lineHeight: '32px' }}>
                                        RT DNS
                                        </Checkbox>
                                        <Checkbox value="LT DNS" style={{ lineHeight: '32px' }}>
                                        LT DNS
                                        </Checkbox>
                                        <Checkbox value="Bilateral DNS" style={{ lineHeight: '32px' }}>
                                        Bilateral DNS
                                        </Checkbox>
                                        <Checkbox value="S-Shaped DNS" style={{ lineHeight: '32px' }}>
                                        S-Shaped DNS
                                        </Checkbox>
                                        <Checkbox value="C-Shaped DNS" style={{ lineHeight: '32px' }}>
                                        C-Shaped DNS
                                        </Checkbox>
                                    </Checkbox.Group>
                                </li>
                                <li><span>Inferior Turbinate</span>
                                    <Radio.Group name="Inferior Turbinate" value={state && state['Inferior Turbinate']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                        <Radio.Button value={'hypertrophic'}>hypertrophic</Radio.Button>
                                        <Radio.Button value={'Atrophic'}>Atrophic</Radio.Button>
                                        <Radio.Button value={'Congested'}>Congested</Radio.Button>
                                    </Radio.Group>
                                </li>
                                <li><span>Middle Turbinate</span>
                                    {/* <Radio.Group name="Middle Turbinate" value={state && state['Middle Turbinate']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                        <Radio.Button value={'hypertrophic'}>hypertrophic</Radio.Button>
                                        <Radio.Button value={'Atrophic'}>Atrophic</Radio.Button>
                                        <Radio.Button value={'Congested'}>Congested</Radio.Button>
                                    </Radio.Group> */}
                                    <Checkbox.Group name="Middle Turbinate" value={state && state['Middle Turbinate']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Middle Turbinate')} size="large">
                                        <Checkbox value="Normal" style={{ lineHeight: '32px' }}>
                                        Normal
                                        </Checkbox>
                                        <Checkbox value="hypertrophic" style={{ lineHeight: '32px' }}>
                                        hypertrophic
                                        </Checkbox>
                                        <Checkbox value="Atrophic" style={{ lineHeight: '32px' }}>
                                        Atrophic
                                        </Checkbox>
                                        <Checkbox value="Congested" style={{ lineHeight: '32px' }}>
                                        Congested
                                        </Checkbox>
                                    </Checkbox.Group>
                                </li>
                                <li><span>Mass</span>
                                    <Radio.Group name="Mass" value={state && state['Mass']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'No Mass'}>No Mass</Radio.Button>
                                        <Radio.Button value={'Single'}>Single</Radio.Button>
                                        <Radio.Button value={'Multiple'}>Multiple</Radio.Button>
                                        <Radio.Button value={'Grade I'}>Grade I</Radio.Button>
                                        <Radio.Button value={'Grade II'}>Grade II</Radio.Button>
                                        <Radio.Button value={'Grade III'}>Grade III</Radio.Button>
                                        <Radio.Button value={'Polypodal'}>Polypodal</Radio.Button>
                                        <Radio.Button value={'Exopytic'}>Exopytic</Radio.Button>
                                        <Radio.Button value={'Infiltrative'}>Infiltrative</Radio.Button>
                                        <Radio.Button value={'Insensible to touch'}>Insensible to touch</Radio.Button>
                                        <Radio.Button value={'Sensible to touch'}>Sensible to touch</Radio.Button>
                                        <Radio.Button value={'No Bleed on touch'}>No Bleed on touch</Radio.Button>
                                        <Radio.Button value={'Bleed on touch'}>Bleed on touch</Radio.Button>
                                    </Radio.Group>
                                </li>
                            </ul>
                        </li>
 
                        <li><span>Nasal Discharge</span>
                            <Radio.Group name="Nasal Discharge 1" value={state && state['Nasal Discharge 1']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Not Present'}>Not Present</Radio.Button>
                                <Radio.Button value={'Serous'}>Serous</Radio.Button>
                                <Radio.Button value={'Mucoid'}>Mucoid</Radio.Button>
                                <Radio.Button value={'Muco-purulant'}>Muco-purulant</Radio.Button>
                                <Radio.Button value={'Purulent'}>Purulent</Radio.Button>
                            </Radio.Group>
                            <Radio.Group name="Nasal Discharge 2" value={state && state['Nasal Discharge 2']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Not Foul smelling'}>Not Foul smelling</Radio.Button>
                                <Radio.Button value={'Foul Smelling'}>Foul Smelling</Radio.Button>
                            </Radio.Group>
                            <Radio.Group name="Nasal Discharge 3" value={state && state['Nasal Discharge 3']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Not Blood Stained'}>Not Blood Stained</Radio.Button>
                                <Radio.Button value={'Blood Stained'}>Blood Stained</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span style={{fontSize:'18px'}}>Tympanic Membrane</span>
                            <ul className='nestedUl'>
                                <li><span>Mobility</span>
                                    <Radio.Group name="Mobility" value={state && state['Mobility']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'No Present'}>Normal with Reduced mobility</Radio.Button>
                                        <Radio.Button value={'Normal with Reduced mobility'}>Normal with Reduced mobility</Radio.Button>
                                        <Radio.Button value={'Abnormal with Reduced mobility'}>Abnormal with Reduced mobility</Radio.Button>
                                    </Radio.Group>
                                </li>
                                <li><span>Retraction</span>
                                    <Radio.Group name="Retraction" value={state && state['Retraction']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'No'}>No</Radio.Button>
                                        <Radio.Button value={'Attic'}>Attic</Radio.Button>
                                        <Radio.Button value={'Other'}>Other</Radio.Button>
                                    </Radio.Group>
                                </li>
                                <li><span>Light Reflex</span>
                                    <Radio.Group name="Light Reflex" value={state && state['Light Reflex']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                        <Radio.Button value={'Abnormal'}>Abnormal</Radio.Button>
                                        <Radio.Button value={'Absent'}>Absent</Radio.Button>
                                    </Radio.Group>
                                </li>
                                <li><span>Perforation</span>
                                    <Radio.Group name="Perforation" value={state && state['Perforation']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'No'}>No</Radio.Button>
                                        <Radio.Button value={'Central'}>Central</Radio.Button>
                                        <Radio.Button value={'Posterio-superior'}>Posterio-superior</Radio.Button>
                                        <Radio.Button value={'Attic'}>Attic</Radio.Button>
                                    </Radio.Group>
                                </li>
                                <li><span>Size of Perforation</span>
                                    <Radio.Group name="Size of Perforation1" value={state && state['Size of Perforation1']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'Anterio-inferior'}>Anterio-inferior</Radio.Button>
                                        <Radio.Button value={'Posterio-superior'}>Posterio-superior</Radio.Button>
                                        <Radio.Button value={'Posterio-inferior'}>Posterio-inferior</Radio.Button>
                                        <Radio.Button value={'Attic'}>Attic</Radio.Button>
                                    </Radio.Group>
                                </li>
                                <li><span>Size of Perforation</span>
                                    <Radio.Group name="Size of Perforation2" value={state && state['Size of Perforation2']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'Small'}>Small</Radio.Button>
                                        <Radio.Button value={'Medium'}>Medium</Radio.Button>
                                        <Radio.Button value={'Large'}>Large</Radio.Button>
                                        <Radio.Button value={'Subtotal'}>Subtotal</Radio.Button>
                                        <Radio.Button value={'Total'}>Total</Radio.Button>
                                    </Radio.Group>
                                </li>
                            </ul>
                        </li>

                        <li><span style={{fontSize:'18px'}}>Hearing</span>
                            <ul className='nestedUl'>
                                <li><span>Voice</span>
                                    <Radio.Group name="Voice" value={state && state['Voice']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                        <Radio.Button value={'Reduced'}>Reduced</Radio.Button>
                                        <Radio.Button value={'Unable to Hear'}>Unable to Hear</Radio.Button>
                                    </Radio.Group>
                                </li>
                                <li><span>Rinne's Test</span>
                                    <Radio.Group name="Rinnes Test" value={state && state['Rinnes Test']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'Not Done'}>Not Done</Radio.Button>
                                        <Radio.Button value={'Attic'}>AC &#60; BC</Radio.Button>
                                        <Radio.Button value={'Other'}>BC &#62; AC</Radio.Button>
                                    </Radio.Group>
                                </li>
                                <li><span>Wabber's Test</span>
                                    <Radio.Group name="Wabbers Test" value={state && state['Wabbers Test']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'Not Done'}>Not Done</Radio.Button>
                                        <Radio.Button value={'Central'}>Central</Radio.Button>
                                        <Radio.Button value={'Lateralized to Right'}>Lateralized to Right</Radio.Button>
                                        <Radio.Button value={'Lateralized to Left'}>Lateralized to Left</Radio.Button>
                                    </Radio.Group>
                                </li>
                                <li><span>ABC Test</span>
                                    <Radio.Group name="ABC Test" value={state && state['ABC Test']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'Not Done'}>Not Done</Radio.Button>
                                        <Radio.Button value={'Same'}>Same</Radio.Button>
                                        <Radio.Button value={'Shortened'}>Shortened</Radio.Button>
                                    </Radio.Group>
                                </li>
                            </ul>
                        </li>
                        <li><span>Facial Nerve</span>
                            <Radio.Group name="Facial Nerve" value={state && state['Facial Nerve']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Intact'}>Intact</Radio.Button>
                                <Radio.Button value={'Rt Sided Palsy'}>Rt Sided Palsy</Radio.Button>
                                <Radio.Button value={'Left Sided Palsy'}>Left Sided Palsy</Radio.Button>
                                <Radio.Button value={'Bilateral Palsy'}>Bilateral Palsy</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Trigeminal Sensations</span>
                            <Radio.Group name="Trigeminal Sensations" value={state && state['Trigeminal Sensations']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Intact'}>Intact</Radio.Button>
                                <Radio.Button value={'Rt Sided absent'}>Rt Sided absent</Radio.Button>
                                <Radio.Button value={'Left Sided absent'}>Left Sided absent</Radio.Button>
                                <Radio.Button value={'Bilateral absent'}>Bilateral absent</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Corneal Sensations</span>
                            <Radio.Group name="Corneal Sensations" value={state && state['Corneal Sensations']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Intact'}>Intact</Radio.Button>
                                <Radio.Button value={'Rt Sided absent'}>Rt Sided absent</Radio.Button>
                                <Radio.Button value={'Left Sided absent'}>Left Sided absent</Radio.Button>
                                <Radio.Button value={'Bilateral absent'}>Bilateral absent</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Extra Ocular Movements</span>
                            <Radio.Group name="Extra Ocular Movements" value={state && state['Extra Ocular Movements']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Intact'}>Intact</Radio.Button>
                                <Radio.Button value={'Lateral Rectus Palsy'}>Lateral Rectus Palsy</Radio.Button>
                                <Radio.Button value={'Superior Oblique Palsy'}>Superior Oblique Palsy</Radio.Button>
                                <Radio.Button value={'Other muscles'}>Other muscles</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Nystagmus</span>
                            <Radio.Group name="Nystagmus" value={state && state['Nystagmus']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Nil'}>Nil</Radio.Button>
                                <Radio.Button value={'Torsinal'}>Torsinal</Radio.Button>
                                <Radio.Button value={'Fast component Rt'}>Fast component Rt</Radio.Button>
                                <Radio.Button value={'Fast component Lt'}>Fast component Lt</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Cerebellar Functions</span>
                            <Radio.Group name="Cerebellar Functions" value={state && state['Cerebellar Functions']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Intact'}>Intact</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Vestibular Functions</span>
                            <Radio.Group name="Vestibular Functions" value={state && state['Vestibular Functions']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Intact'}>Intact</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span style={{fontSize:'18px'}}>Pure Tone Audiometry</span>
                            <ul className='nestedUl'>
                                <li><span>Type of hearing Loss</span>
                                    <Radio.Group name="Type of hearing Loss" value={state && state['Type of hearing Loss']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'No Loss'}>No Loss</Radio.Button>
                                        <Radio.Button value={'Conductive HL'}>Conductive HL</Radio.Button>
                                        <Radio.Button value={'Sensory-neural HL'}>Sensory-neural HL</Radio.Button>
                                        <Radio.Button value={'Mixed HL'}>Mixed HL</Radio.Button>
                                        <Radio.Button value={'Remarks'}>Remarks</Radio.Button>
                                    </Radio.Group>
                                </li>
                                <li><span>Severity</span>
                                    <Radio.Group name="Severity" value={state && state['Severity']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                        <Radio.Button value={'Nil'}>Nil</Radio.Button>
                                        <Radio.Button value={'Mild'}>Mild</Radio.Button>
                                        <Radio.Button value={'Moderate'}>Moderate</Radio.Button>
                                        <Radio.Button value={'Moderate Severe'}>Moderate Severe</Radio.Button>
                                        <Radio.Button value={'ASeverettic'}>Severe</Radio.Button>
                                        <Radio.Button value={'Profound'}>Profound</Radio.Button>
                                        <Radio.Button value={'Totals'}>Totals</Radio.Button>
                                    </Radio.Group>
                                </li>
                                
                            </ul>
                        </li>
                        <Button className="SaveFormButton" loading={loadingBtn} onClick={saveTheForm} type="primary">Save</Button>
                        

                    </ul>

                : ''

                }
                </>}
            </React.Fragment>
 
        </div>
    );
}

export default LeftNose;
